const types = {
    FIRST_SET: 'FIRST_SET',
    LANGUAGES_ADD: 'LANGUAGES_ADD',
    LANGUAGE_SET: 'LANGUAGE_SET'
}


const state = {
    firstSet: true, // 判斷是否第一次設定語系
    languages: Array(),
    nowlanguage: "zh-TW"
}


const getters = {
    isFirstSet: state => state.firstSet,
    getLanguages: state => state.languages,
    getNowLanguage: state => state.nowlanguage
}


const actions = {
    actionIsFirstSet({ commit }, isFirstSet) {
        commit(types.FIRST_SET, isFirstSet);
    },
    actionAddLanguages({ commit }, language) {
        commit(types.LANGUAGES_ADD, language);
    },
    actionSetNowLanguage({commit}, language){
        commit(types.LANGUAGE_SET, language)
    }
}


const mutations = {
    [types.FIRST_SET](state, isFirstSet) {
        state.firstSet = isFirstSet;
    },
    [types.LANGUAGES_ADD](state, language) {
        state.languages.push(language);
    },
    [types.LANGUAGE_SET](state, language){
        state.nowlanguage = language;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}